module.exports = __webpack_public_path__ + "8f2670921e1283dcaf2e8814136038cb.pdf";